import isEmail from 'validator/lib/isEmail'

export default function isEmailValidator(payload: string): boolean {
  const emailRegex: RegExp = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/

  const isValidEmail = (email: string): boolean => {
    return emailRegex.test(email)
  }

  return isEmail(payload) && isValidEmail(payload)
}
